module.exports = __webpack_public_path__ + "media/images/front/banner_premium_campaign_side_old-7dab2fd5aec5260fee1eab0c5e27341a.jpg";